@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'manageEvent.sponsors.loading' | translate }}</p>
  </div>
} @else {
  <div class="d-flex flex-wrap flex-stack mb-6">
    <h3 class="fw-bold my-2">{{ 'manageEvent.sponsors.title' | translate }}</h3>
    <div class="d-flex flex-wrap my-2">
      <app-button
        [variant]="'primary'"
        [label]="'manageEvent.sponsors.addSponsor' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openModal()"
      />
    </div>
  </div>
  <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
    @for (sponsor of sponsors; track sponsor.sponsor_id) {
      <div class="col-md-4">
        <app-sponsor-card
          [sponsor]="sponsor"
          (editSponsorClick)="openEditModal($event)"
          (deleteSponsorClick)="deleteSponsor($event)"
        />
      </div>
    }
    @if (!sponsors || sponsors.length === 0) {
      <div class="col-12 text-center text-muted py-10">{{ 'manageEvent.sponsors.noSponsors' | translate }}</div>
    }
  </div>
}

